import { Circle, useTheme } from "tamagui";

import { Button } from "@/components/Button";
import { Text } from "@/components/Typography";

interface PressableProps {
  title: string;
  isSelected?: boolean;
  onPress: () => void;
  Icon?: React.ElementType;
  indicatorColor?: string;
}

export const Pressable = ({
  title,
  isSelected = false,
  onPress,
  Icon,
  indicatorColor,
}: PressableProps) => {
  const theme = useTheme();
  const iconColor = theme["iconBase"]?.get();
  return (
    <Button.Wrapper
      flexDirection="row"
      alignItems="center"
      gap="$50"
      dataTrackingId="conversation-history-item"
      flex={1}
      onPress={onPress}
      paddingVertical="$125"
      paddingHorizontal="$100"
      backgroundColor={isSelected && "$navSelected"}
      borderRadius="$150"
      aria-current={isSelected ? "page" : undefined}
      justifyContent="flex-start"
      hoverStyle={{
        backgroundColor: "$navHover",
      }}
      focusVisibleStyle={{
        borderColor: "$outlineColor",
        borderWidth: "$strokeWidth",
        borderStyle: "solid",
      }}
    >
      {Boolean(indicatorColor) && (
        <Circle backgroundColor={indicatorColor} size="$75" />
      )}
      <Text
        flexGrow={1}
        size="$md"
        color={isSelected ? "$textPrimary" : "$textSecondary"}
        numberOfLines={1}
        ellipsizeMode="tail"
      >
        {title}
      </Text>
      {Icon && <Icon color={iconColor} />}
    </Button.Wrapper>
  );
};

export default Pressable;
